import React, { useState } from 'react'

export default function ConfirmationModal({proceed = false, cancel, message, cancelButton = 'Cancel'}) {

  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
                <div className="bg-white mx-auto rounded shadow p-5 text-center">
                    <div>{message}</div>
                    <div className="pt-3">
                        {proceed &&
                        <button onClick={proceed} type="button" className="btn btn-primary mr-2">
                            Proceed
                        </button>
                        }

                        <button onClick={cancel} type="button" className="btn btn-secondary mr-2">
                            { cancelButton }
                        </button>
                    </div>
                </div>
    </div>
    </div>
  )
}
